export var ONE_MB = 1048576;